module.exports = __webpack_public_path__ + "img/pic6.cd6be9c2.png";